var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-upload',{staticClass:"s-download-plain",attrs:{"action":_vm.url,"http-request":_vm.upload,"show-file-list":false,"before-upload":_vm.checkFileSizeAndType}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }